import Button from '../../Buttons';
import Icon from '../../Icon';
import Typography from '../../Typography';
import { FC } from 'react';

type Props = {
	page: number;
	pageMax: number;
	onPrevious: () => void;
	onNext: () => void;
};

const Navigation: FC<Props> = ({ onNext, onPrevious, page, pageMax }) => {
	return (
		<div className="flex items-center justify-center gap-6 md:gap-16">
			<Button
				aria-label="Página anterior"
				variant="general"
				size="small"
				lg="medium"
				className="bg-transparent gap-8 px-10 h-[44px] w-[44px] md:h-auto md:w-auto"
				onClick={onPrevious}
				disabled={page === 1}
			>
				<Icon name="arrow-left" />
				<span className="hidden lg:inline">Página anterior</span>
			</Button>

			<Typography variant="body-2" className="text-base-grey-6">
				Página {page} de {pageMax}
			</Typography>

			<Button
				aria-label="Próxima página"
				variant="general"
				size="small"
				lg="medium"
				className="bg-transparent gap-8 px-10 h-[44px] w-[44px] md:h-auto md:w-auto"
				onClick={onNext}
				disabled={page === pageMax}
			>
				<span className="hidden lg:inline">Próxima página</span>
				<Icon name="arrow-right" />
			</Button>
		</div>
	);
};

export default Navigation;
